import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { fetchOverlays } from '../actions'
import ShowOverlays from '../components/overlays/ShowOverlays';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
}

class OverlaysPage extends React.Component {
  constructor(){
    super();
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount(){
    console.log('fetching Overlays')
    this.props.dispatch(fetchOverlays())
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="settings component" style={authPage}>
        <ShowOverlays />
      </div>
    );
  }
}


OverlaysPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OverlaysPage.propTypes = propTypes;

export default connect()(OverlaysPage);



// WEBPACK FOOTER //
// ./src/containers/OverlaysPage.js